import { useState, useEffect } from 'react';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MapScreen from './MapScreen';
import ItineraryView from './components/ItineraryView';

const SUGGESTIONS = {
  home: [
    'New York',
    'London',
    'Los Angeles',
    'Chicago',
    'San Francisco',
    'Miami',
    'Boston',
    'Seattle',
    'Paris',
    'Tokyo',
  ],
  translate: [
    'Madrid',
    'Paris',
    'Tokyo',
    'Rome',
    'Barcelona',
    'Amsterdam',
    'Lisbon',
    'Berlin',
    'Mexico City',
    'Dubai',
  ],
};

function CityMirrorLanding() {
  const [launched, setLaunched] = useState(() =>
    sessionStorage.getItem('cm_launched') === 'true',
  );
  const [home, setHome] = useState(() =>
    sessionStorage.getItem('cm_home') || '',
  );
  const [translate, setTranslate] = useState(() =>
    sessionStorage.getItem('cm_translate') || '',
  );
  const [homeFocus, setHomeFocus] = useState(false);
  const [transFocus, setTransFocus] = useState(false);

  useEffect(() => {
    sessionStorage.setItem('cm_launched', launched);
    sessionStorage.setItem('cm_home', home);
    sessionStorage.setItem('cm_translate', translate);
  }, [launched, home, translate]);

  const homeSuggestions = SUGGESTIONS.home
    .filter(
      (c) =>
        home.length > 0 &&
        c.toLowerCase().startsWith(home.toLowerCase()) &&
        c.toLowerCase() !== home.toLowerCase()
    )
    .slice(0, 4);

  const transSuggestions = SUGGESTIONS.translate
    .filter(
      (c) =>
        translate.length > 0 &&
        c.toLowerCase().startsWith(translate.toLowerCase()) &&
        c.toLowerCase() !== translate.toLowerCase()
    )
    .slice(0, 4);

  const canGo = home.trim().length > 1 && translate.trim().length > 1;
  if (launched) {
    return (
      <MapScreen
        homeCity={home}
        translateCity={translate}
        onBack={() => setLaunched(false)}
      />
    );
  }
  return (
    <div
      style={{
        fontFamily: "'DM Sans','Helvetica Neue',sans-serif",
        background: '#0a0908',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes fadeDown {
          from { opacity: 0; transform: translateY(-20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }

        .cm-input {
          width: 100%;
          background: rgba(12, 11, 10, 0.75);
          border: 1px solid #2d2b27;
          border-radius: 5px;
          padding: 16px 20px 16px 48px;
          font-family: 'DM Sans', sans-serif;
          font-size: 15px;
          font-weight: 400;
          color: #f0ebe3;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          letter-spacing: 0.01em;
        }
        .cm-input::placeholder { color: #3e3b37; }
        .cm-input:focus {
          border-color: rgba(200,169,110,0.7);
          box-shadow: 0 0 0 3px rgba(200,169,110,0.07);
          background: rgba(16, 14, 12, 0.88);
        }

        .go-btn {
          width: 100%;
          background: #c8a96e;
          border: none;
          border-radius: 5px;
          padding: 17px;
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #0a0908;
          cursor: pointer;
          transition: all 0.22s;
        }
        .go-btn:hover:not(:disabled) {
          background: #d4b87a;
          transform: translateY(-1px);
          box-shadow: 0 8px 28px rgba(200,169,110,0.28);
        }
        .go-btn:active:not(:disabled) {
          transform: translateY(0);
        }
        .go-btn:disabled {
          opacity: 0.25;
          cursor: not-allowed;
        }

        .suggest-item {
          padding: 11px 20px;
          font-size: 13px;
          color: #8a8278;
          cursor: pointer;
          transition: all 0.12s;
          border-bottom: 1px solid #1a1815;
          letter-spacing: 0.01em;
        }
        .suggest-item:hover {
          background: #1a1815;
          color: #c8a96e;
          padding-left: 24px;
        }
        .suggest-item:last-child { border-bottom: none; }
      `}</style>

      {/* ── BACKGROUND PHOTO ── */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url('https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1600&q=80')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.18,
          filter: 'saturate(0.6) brightness(0.85)',
        }}
      />

      {/* Inline base64 fallback — the image rendered as a background */}
      <img
        src="https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1600&q=80"
        alt=""
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
          opacity: 0.18,
          filter: 'saturate(0.55) brightness(0.8)',
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      />

      {/* Top vignette — darkens upper third so wordmark pops */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(to bottom, #0a0908 0%, rgba(10,9,8,0.7) 28%, rgba(10,9,8,0.4) 50%, rgba(10,9,8,0.7) 72%, #0a0908 100%)',
          pointerEvents: 'none',
        }}
      />

      {/* Radial center glow — very subtle warm wash behind the inputs */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          height: 500,
          borderRadius: '50%',
          background:
            'radial-gradient(ellipse, rgba(200,169,110,0.04) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      {/* ── CONTENT ── */}
      <div
        style={{
          position: 'relative',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: 460,
          padding: '0 28px',
        }}
      >
        {/* EYEBROW */}
        <div
          style={{
            animation: 'fadeDown 0.65s cubic-bezier(0.16,1,0.3,1) both',
            textAlign: 'center',
            marginBottom: 22,
          }}
        >
          <div
            style={{
              fontSize: 10,
              fontWeight: 500,
              letterSpacing: '0.26em',
              textTransform: 'uppercase',
              color: '#524e49',
            }}
          >
            Every City. Like You Know It.
          </div>
        </div>

        {/* WORDMARK */}
        <div
          style={{
            animation: 'fadeDown 0.7s 0.05s cubic-bezier(0.16,1,0.3,1) both',
            textAlign: 'center',
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(58px, 11vw, 88px)',
              fontWeight: 900,
              lineHeight: 0.92,
              letterSpacing: '-0.03em',
              color: '#f0ebe3',
              userSelect: 'none',
            }}
          >
            City
          </div>
          <div
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(58px, 11vw, 88px)',
              fontWeight: 900,
              lineHeight: 0.92,
              letterSpacing: '-0.03em',
              color: '#c8a96e',
              userSelect: 'none',
            }}
          >
            Mirror
          </div>
        </div>

        {/* RULE */}
        <div
          style={{
            animation: 'fadeIn 0.8s 0.2s both',
            width: '100%',
            height: 1,
            background:
              'linear-gradient(to right, transparent, #2a2825 20%, #2a2825 80%, transparent)',
            margin: '26px 0',
          }}
        />

        {/* INPUTS */}
        <div
          style={{
            width: '100%',
            animation: 'fadeUp 0.7s 0.18s cubic-bezier(0.16,1,0.3,1) both',
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
          }}
        >
          {/* HOME */}
          <div style={{ position: 'relative' }}>
            <div
              style={{
                position: 'absolute',
                top: -9,
                left: 14,
                zIndex: 2,
                fontSize: 9,
                fontWeight: 500,
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: '#524e49',
                background: '#0a0908',
                padding: '0 6px',
              }}
            >
              Homebase
            </div>

            <div
              style={{
                position: 'absolute',
                left: 18,
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: 15,
                zIndex: 1,
                pointerEvents: 'none',
                color: homeFocus ? '#c8a96e' : '#3e3b37',
                transition: 'color 0.2s',
              }}
            >
              ⌂
            </div>

            <input
              className="cm-input"
              placeholder="City you know well…"
              value={home}
              onChange={(e) => setHome(e.target.value)}
              onFocus={() => setHomeFocus(true)}
              onBlur={() => setTimeout(() => setHomeFocus(false), 160)}
              autoComplete="off"
            />

            {homeFocus && homeSuggestions.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: 'calc(100% + 4px)',
                  left: 0,
                  right: 0,
                  background: 'rgba(16,14,12,0.97)',
                  border: '1px solid #2d2b27',
                  borderRadius: 5,
                  overflow: 'hidden',
                  zIndex: 50,
                  backdropFilter: 'blur(12px)',
                  animation: 'fadeDown 0.15s ease-out',
                }}
              >
                {homeSuggestions.map((s) => (
                  <div
                    key={s}
                    className="suggest-item"
                    onMouseDown={() => setHome(s)}
                  >
                    {s}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* ARROW DIVIDER */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '0 2px',
            }}
          >
            <div style={{ flex: 1, height: 1, background: '#1a1815' }} />
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                border: '1px solid #252320',
                background: 'rgba(12,11,10,0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <span style={{ color: '#c8a96e', fontSize: 13, lineHeight: 1 }}>
                ↓
              </span>
            </div>
            <div style={{ flex: 1, height: 1, background: '#1a1815' }} />
          </div>

          {/* TRANSLATE */}
          <div style={{ position: 'relative' }}>
            <div
              style={{
                position: 'absolute',
                top: -9,
                left: 14,
                zIndex: 2,
                fontSize: 9,
                fontWeight: 500,
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: '#524e49',
                background: '#0a0908',
                padding: '0 6px',
              }}
            >
              Translate
            </div>

            <div
              style={{
                position: 'absolute',
                left: 17,
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: 14,
                zIndex: 1,
                pointerEvents: 'none',
                color: transFocus ? '#c8a96e' : '#3e3b37',
                transition: 'color 0.2s',
              }}
            >
              ◎
            </div>

            <input
              className="cm-input"
              placeholder="City you want to explore…"
              value={translate}
              onChange={(e) => setTranslate(e.target.value)}
              onFocus={() => setTransFocus(true)}
              onBlur={() => setTimeout(() => setTransFocus(false), 160)}
              autoComplete="off"
            />

            {transFocus && transSuggestions.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: 'calc(100% + 4px)',
                  left: 0,
                  right: 0,
                  background: 'rgba(16,14,12,0.97)',
                  border: '1px solid #2d2b27',
                  borderRadius: 5,
                  overflow: 'hidden',
                  zIndex: 50,
                  backdropFilter: 'blur(12px)',
                  animation: 'fadeDown 0.15s ease-out',
                }}
              >
                {transSuggestions.map((s) => (
                  <div
                    key={s}
                    className="suggest-item"
                    onMouseDown={() => setTranslate(s)}
                  >
                    {s}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* CTA */}
          <div style={{ marginTop: 6 }}>
            <button
              className="go-btn"
              disabled={!canGo}
              onClick={() => canGo && setLaunched(true)}
            >
              {launched ? `Translating ${translate}…` : 'Mirror this city →'}
            </button>
          </div>

          {/* Status line */}
          <div
            style={{
              textAlign: 'center',
              marginTop: 4,
              fontSize: 11,
              letterSpacing: '0.05em',
              color: canGo ? '#2d2b27' : '#1e1c18',
              animation: 'fadeIn 1s 0.5s both',
              transition: 'color 0.3s',
            }}
          >
            {canGo ? `${home}  →  ${translate}` : 'Enter two cities to begin'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/itinerary/:id" element={<ItineraryView />} />
        <Route path="*" element={<CityMirrorLanding />} />
      </Routes>
    </BrowserRouter>
  );
}
